
import React from 'react';

interface TimerControlButtonProps {
  onClick: (e: React.MouseEvent) => void;
  children: React.ReactNode;
  size?: 'small' | 'large';
  ariaLabel: string;
}

const TimerControlButton: React.FC<TimerControlButtonProps> = ({
  onClick,
  children,
  size = 'small',
  ariaLabel
}) => {
  // Use direct click handler without event prevention to ensure events propagate correctly
  const handleClick = (e: React.MouseEvent) => {
    console.log(`Timer control button clicked: ${ariaLabel}`);
    onClick(e);
  };

  return (
    <button 
      onClick={handleClick}
      className={`bg-black/30 border border-white/30 rounded-full transition-all hover:bg-black/40 flex items-center justify-center text-white cursor-pointer
        ${size === 'large' ? 'w-14 h-14 sm:w-16 sm:h-16' : 'w-10 h-10 sm:w-12 sm:h-12'}`}
      type="button"
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export default TimerControlButton;
